<template>
<div>
    <div
        style="position: relative"
    >
        <span :style="$rc.styleInputLabel()">{{label}}</span>
        <ul>
            <li
                v-for="(item, index) in value"
                :key="'mp_'+index"
                v-html="$rc.wrapHTML(item)"
                style="margin-bottom: 15px"
            >
                
            </li>
        </ul>

        <div
            style="position: absolute; top: 0px; right: 0px"
            v-if="!disabled"
        >
            <v-icon
                color="primary"
                v-on:click="showDialog()"
            >
                mdi-lead-pencil
            </v-icon>
        </div>
    </div>

    <v-dialog
        v-model="dialog"
        max-width="1200"
        fullscreen
    >
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{label}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onOk"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card>

            <v-card-text>
                <br/>
                <m-edit-message-patterns
                    v-model="dialog_value"
                    :context="context"
                    :always_mms="always_mms"
                    :bulk_message_id="bulk_message_id"
                />
            </v-card-text>

        </v-card>
    </v-dialog>
</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        label: {
            type: String,
            default: function() { return 'Message Patterns'; }, 
        },

        context: {
            type: String,
            default: function() { return 'manually-sent'; }
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        always_mms: {
            type: Boolean,
            default: function() { return false; }
        },

        disabled: {
            type: Boolean,
            default: function() { return false; }
        },

        bulk_message_id: {
            type: String,
            default: function() { return null; }
        },

        default_value: {
            type: Array,
            default: function() { return null; }
        }
    },

    data() {
        return {
            dialog: false,
            dialog_value: [],
        }
    },

    methods: {

        showDialog()
        {
            let initial_value = _.cloneDeep(this.value);

            if ( this.default_value != null && initial_value.length == 0 )
            {
                initial_value = _.cloneDeep(this.default_value);
            }

            this.dialog_value = initial_value;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        onOk()
        {
            this.$emit('input', this.dialog_value);
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.onOk();
            next(false);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>